import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CustomerAuthProvider } from '@/contexts/CustomerAuthContext';
import { CustomerProtectedRoute } from './guards';

const CustomerLogin = lazy(() => import('@/pages/customer/Login'));
const CustomerDashboard = lazy(() => import('@/pages/customer/Dashboard'));
const CustomerRoutes_ = lazy(() => import('@/pages/customer/Routes'));
const CustomerBilling = lazy(() => import('@/pages/customer/Billing'));
const CustomerProfile = lazy(() => import('@/pages/customer/Profile'));

export function CustomerRoutes() {
  return (
    <CustomerAuthProvider>
      <Routes>
        <Route path="login" element={<CustomerLogin />} />
        <Route path="dashboard" element={<CustomerProtectedRoute><CustomerDashboard /></CustomerProtectedRoute>} />
        <Route path="routes" element={<CustomerProtectedRoute><CustomerRoutes_ /></CustomerProtectedRoute>} />
        <Route path="billing" element={<CustomerProtectedRoute><CustomerBilling /></CustomerProtectedRoute>} />
        <Route path="profile" element={<CustomerProtectedRoute><CustomerProfile /></CustomerProtectedRoute>} />
        <Route path="" element={<Navigate to="/customer/login" replace />} />
      </Routes>
    </CustomerAuthProvider>
  );
}
